import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/card';
import { SwitchField } from '@/modules/common/components/molecules/inputs/switch-field';

import { FORM_FIELD_IS_APPROVAL_REQUIRED } from '../../../../constants/time-off-type-form-fields';
import { TimeOffTypeSetupFormData } from '../../../../validations/time-off-type-validation';

interface ApprovalRulesSectionProps {
  form: UseFormReturn<TimeOffTypeSetupFormData>;
  isReadMode: boolean;
}

export function ApprovalRulesSection({ form, isReadMode }: ApprovalRulesSectionProps) {
  const { t } = useTranslation('authenticated.settings');

  return (
    <Card>
      <CardContent className="space-y-4 p-6">
        <div>
          <h3 className="text-md font-semibold">
            {t('pages.timeOff.details.sections.approval.title')}
          </h3>
          <p className="mt-0.5 text-xs text-muted-foreground">
            {t('pages.timeOff.details.sections.approval.description')}
          </p>
        </div>

        <SwitchField
          name={FORM_FIELD_IS_APPROVAL_REQUIRED}
          control={form.control}
          label={t('pages.timeOff.details.sections.approval.required')}
          disabled={isReadMode}
        />
      </CardContent>
    </Card>
  );
}
